const TEMPLATE_IDS = {
  PRODUCTION: {
    IS_SUBACCOUNT: 'dd8bd97e-e021-47ec-b9cd-554275dfec0a',
    IS_NOT_SUBACCOUNT: '725aa2e5-8cbd-445a-8edb-3fcfd10d54e9',
  },
  SANDBOX: {
    IS_SUBACCOUNT: '7ff0571e-b07d-4ab2-a055-c4b1bbc35d3a',
    IS_NOT_SUBACCOUNT: 'b7845237-168c-4b3e-930c-a16322ead33a',
  },
};

const AI_PRISE_ENV = import.meta.env.VITE_AI_PRISE_ENV as
  | 'SANDBOX'
  | 'PRODUCTION';

enum KycStatuses {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  VERIFICATION_SESSION_STARTED = 'VERIFICATION_SESSION_STARTED',
  VERIFICATION_REQUEST_SUBMITTED = 'VERIFICATION_REQUEST_SUBMITTED',
  VERIFICATION_SESSION_COMPLETION = 'VERIFICATION_SESSION_COMPLETION',
}

export { TEMPLATE_IDS, AI_PRISE_ENV, KycStatuses };
